import { resolveAbilityId } from "../catalogs/characterSystemCatalog";

class Skill {
  constructor(json) {
    this.id = json.id;
    if (json.catalogId) this.catalogId = json.catalogId;
    if (json.name && !json.catalogId) this.name = json.name;
    this.modifier = Number(json.modifier);
    this.abilityId = resolveAbilityId(
      json.abilityId || json.mainCharacteristicName
    );
    this.playerSkillPoints = Number(json.playerSkillPoints);
    this.isClassSkill = Boolean(json.isClassSkill);
    this.manualIsClassSkill = Boolean(json.manualIsClassSkill ?? json.isClassSkill);
    this.ruleClassSkill = Boolean(json.ruleClassSkill);
    this.ruleBonus = Number(json.ruleBonus) || 0;
  }
}

export default Skill;
